<template>
    <v-card v-redirect-if-no-permission:DEMAND_PUMP>
        <loading-component :value="loading"></loading-component>
        <v-card-title primary-title class="font-weight-bold title">Demand Pump</v-card-title>
        <v-divider/>
        <v-card-text>
            <v-form ref="form">
                <v-layout row wrap>
                    <v-flex xs12>
                        <h1 style="text-align: center">{{demand.code}} <span><v-icon @click="generateCode"
                                                                                     :disabled="generating_random"
                                                                                     style="padding-bottom: 6px;cursor: pointer">fa-refresh</v-icon></span>
                        </h1>
                    </v-flex>
                    <v-flex xs12 md5>
                        <v-text-field v-model="demand.bookings_limit" prepend-icon="fa fa-hashtag"
                                      :rules="requiredRules"
                                      :label="'Number of bookings (Generated Vouchers ' +  (demand.bookings_limit * 20) + ')'"
                                      required></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-switch style="display: inline-block" v-model="demand.new_passengers" :rules="requiredRules"
                                  :label="'New passengers' + (demand.new_passengers ? ' (yes)' : ' (no)')"/>
                        <v-switch style="display: inline-block;margin-left: 15px" v-model="demand.exclude_given_today"
                                  :rules="requiredRules"
                                  :label="'Exclude who given today' + (demand.exclude_given_today ? ' (yes)' : ' (no)')"/>
                    </v-flex>
                    <v-flex xs12 md5>
                        <choose-location-multi :rules="requiredRules"
                                               v-model="demand.areas"
                                               label="Custom areas (leave it blank to allow all)"/>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-select
                                v-model="demand.black_list_areas"
                                :rules="requiredRules"
                                :items="black_list_areas"
                                label="Black list areas"
                                multiple
                                item-value="id"
                                item-text="name"
                                prepend-icon="fa fa-ban">
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                    <span>{{ item.name }}</span>
                                </v-chip>
                                <span v-if="index === 1"
                                      class="grey--text caption">(+{{ demand.black_list_areas.length - 1 }} others)</span>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 md5>
                        <v-select v-model="demand.target" :rules="requiredRules" prepend-icon="fa fa-bullseye"
                                  :items="targets" item-value="key" item-text="value"
                                  label="Demand Target"></v-select>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-select v-model="demand.amount" :rules="requiredRules" prepend-icon="fa fa-percent"
                                  :items="amounts"
                                  label="Discount"></v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-card style="margin-bottom: 10px;margin-top: 10px">
                            <v-card-title>
                                <h3>Voucher time</h3>
                            </v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs12 md5>
                                        <v-menu :nudge-right="40" :close-on-content-click="false" lazy
                                                transition="scale-transition"
                                                offset-y full-width max-width="290px" min-width="290px">
                                            <template slot="activator">
                                                <v-text-field :rules="requiredRules" label="From" persistent-hint
                                                              :value="demand.voucher_start_time"
                                                              prepend-icon="fa fa-hourglass"></v-text-field>
                                            </template>
                                            <v-time-picker format="24hr" v-model="demand.voucher_start_time"/>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md5 offset-md2 :class="{times_section: true,active: false}">
                                        <v-menu :nudge-right="40" :close-on-content-click="false" lazy
                                                transition="scale-transition"
                                                offset-y full-width max-width="290px" min-width="290px">
                                            <template slot="activator">
                                                <v-text-field :rules="requiredRules" label="To" persistent-hint
                                                              :value="demand.voucher_end_time"
                                                              prepend-icon="fa fa-hourglass"></v-text-field>
                                            </template>
                                            <v-time-picker format="24hr" v-model="demand.voucher_end_time"
                                                           :min="demand.voucher_start_time"/>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-card style="margin-bottom: 10px;margin-top: 10px">
                            <v-card-title>
                                <h3>Only passengers who demand in specific period(not required) <b
                                        v-if="demand.target === 'LOST'"> - no effect for Lost Customers target</b></h3>
                            </v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs12 md5>
                                        <v-menu :nudge-right="40" :close-on-content-click="false" lazy
                                                transition="scale-transition"
                                                offset-y full-width max-width="290px" min-width="290px">
                                            <template slot="activator">
                                                <v-text-field label="From" persistent-hint
                                                              :value="demand.demand_start_time"
                                                              prepend-icon="fa fa-hourglass"></v-text-field>
                                            </template>
                                            <v-time-picker format="24hr" v-model="demand.demand_start_time"/>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md5 offset-md2 :class="{times_section: true,active: false}">
                                        <v-menu :nudge-right="40" :close-on-content-click="false" lazy
                                                transition="scale-transition"
                                                offset-y full-width max-width="290px" min-width="290px">
                                            <template slot="activator">
                                                <v-text-field label="To" persistent-hint :value="demand.demand_end_time"
                                                              prepend-icon="fa fa-hourglass"></v-text-field>
                                            </template>
                                            <v-time-picker format="24hr" v-model="demand.demand_end_time"
                                                           :min="demand.demand_start_time"/>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-card style="margin-bottom: 10px;margin-top: 10px">
                            <v-card-title>
                                <h3>Message</h3>
                            </v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs12 md5>
                                        <v-select
                                                v-model="demand.broadcast"
                                                :items="['SMS', 'Whatsapp', 'Notification']"
                                                attach
                                                chips
                                                label="Broadcast Use"
                                                multiple
                                        ></v-select>
                                    </v-flex>
                                    <v-flex offset-md2 md5 xs12>
                                        <v-select
                                                :disabled="!demand.broadcast.includes('Whatsapp')"
                                                v-model="demand.whatsapp_from"
                                                :items="api.CONSTANTS.WHATSAPP_NUMBERS"
                                                attach
                                                chips
                                                label="Whatsapp Number"
                                        ></v-select>
                                    </v-flex>
                                    <v-textarea :rules="requiredRules" label="Message"
                                                v-model="demand.message"></v-textarea>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4 offset-md4 text-xs-right>
                        <v-btn @click="submit" style="width: 100%" color="primary">Generate Vouchers</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>

    import ChooseLocationMulti from "@/components/wasilni/input/ChooseLocationMulti";
    import LoadingComponent from "@/components/LoadingComponent";
    export default {
        name: "DemandPump",
        title: 'Demand Pump',
        components: {LoadingComponent, ChooseLocationMulti},
        data() {
            return {
                loading: false,
                generating_random: false,
                requiredRules: [
                    v => v !== null && v !== undefined && v !== '' || 'This Field Is Required',
                ],
                demand: {
                    code: '4dq1',
                    bookings_limit: 10,
                    areas: [],
                    exclude_given_today: true,
                    new_passengers: true,
                    demand_start_time: '',
                    demand_end_time: '',
                    voucher_start_time: '',
                    voucher_end_time: '',
                    black_list_areas: [],
                    broadcast: [],
                    message: '',
                    whatsapp_from: null,
                    target: '',
                    amount: null
                },
                targets: [],
                amounts: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
                black_list_areas: [],
                show_locations: false
            }
        },
        methods: {
            submit() {
                if (!this.$refs.form.validate() || this.demand.message.search(this.demand.amount) === -1 || this.demand.broadcast.includes('Whatsapp') && !this.demand.whatsapp_from || this.demand.message.search(this.demand.code) === -1) {
                    if (this.demand.broadcast.includes('Whatsapp') && !this.demand.whatsapp_from) {
                        window.getApp.$emit("SHOW_TOAST", "check voucher message info", "red");
                    } else if (this.demand.message.search(this.demand.code) === -1) {
                        window.getApp.$emit("SHOW_TOAST", "message doesn't contain voucher code", "red");
                    } else if (this.demand.message.search(this.demand.amount) === -1) {
                        window.getApp.$emit("SHOW_TOAST", "message doesn't contain voucher amount or invalid amount in message", "red");
                    }
                    return;
                }
                this.loading = true;
                this.axios.post('voucher/demand_pump', this.demand)
                    .then(res => {
                        this.$refs.form.reset();
                        this.generateCode();
                        window.getApp.$emit("SHOW_TOAST", res.data.message, "green");
                    })
                    .catch((err) => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red");
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    })
                    .finally(() => this.loading = false);
            },
            generateCode() {
                this.generating_random = true;
                this.axios.get(this.api.ACTIONS.RANDOM_VOUCHER).then(({data}) => {
                    this.demand.code = data.data;
                    this.generating_random = false;
                })
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get('voucher/demand_pump/init')
                .then(res => {
                    this.demand.code = res.data.data.code;
                    this.black_list_areas = res.data.data.black_list_areas;
                    this.targets = res.data.data.targets;
                }).catch(err => console.log(err.message))
                .finally(() => this.loading = false);
        }
    }
</script>

<style scoped>

</style>